module.exports = __webpack_public_path__ + "img/logo.fe4b0928.svg";